import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useConfig } from '../../contexts/config-context';
import Fieldset from '../fieldset';
import { TimePickerWUT } from '../time-picker';
import { classes } from './date-time-field.st.css';
import styles from './date-time-field.module.scss';
import { DatePickerWUT } from '../date-picker/date-picker-wut';
import { parseDateTimeValue, formatDateTimeValue } from './date-time-field-utils';
export function DateTimeFieldWUT(_ref) {
  let {
    use24HourFormat = false,
    onBlur,
    onChange,
    onFocus,
    inputId,
    ariaLabelledBy,
    value,
    id,
    disabled,
    errors,
    hidePlaceholder,
    showDateLabels,
    required,
    ariaDescribedBy
  } = _ref;
  const {
    isMobile
  } = useConfig();
  const [date, time] = useMemo(() => parseDateTimeValue(value), [value]);
  return /*#__PURE__*/React.createElement(Fieldset, {
    id: inputId,
    onFocus: onFocus,
    onBlur: onBlur,
    ariaLabelledBy: ariaLabelledBy,
    className: classNames(styles.fields, classes.gap, {
      [styles.mobile]: isMobile
    }),
    ariaDescribedBy: ariaDescribedBy,
    required: required
  }, /*#__PURE__*/React.createElement(DatePickerWUT, {
    disabled: disabled,
    errors: errors,
    hidePlaceholder: hidePlaceholder,
    showDateLabels: showDateLabels,
    required: required,
    inputId: inputId,
    id: id,
    onChange: newDate => onChange(formatDateTimeValue(newDate, time)),
    value: date
  }), /*#__PURE__*/React.createElement(TimePickerWUT, {
    inputId: inputId,
    disabled: disabled,
    readOnly: false,
    error: errors.TIME,
    hidePlaceholder: hidePlaceholder,
    showTimeLabel: showDateLabels,
    required: required,
    className: styles.time,
    "data-hook": `${id}-time`,
    use24Hours: use24HourFormat,
    onChange: newTime => onChange(formatDateTimeValue(date, newTime)),
    value: time
  }));
}
//# sourceMappingURL=date-time-field-wut.js.map